import {
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  split,
} from "@apollo/client/core";
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';
import { setContext } from "@apollo/client/link/context";
import { getAccessToken } from "@/utils/token";
import { getGraphqlUrl } from "@/utils/apiUrl";
import i18n from "@/i18n";

// Upload link for HTTP operations (queries and mutations)
const uploadLink = createUploadLink({
  uri: getGraphqlUrl(),
  // Increase timeout for file uploads (5 minutes)
  fetchOptions: {
    timeout: 300000, // 5 minutes
  },
  // credentials: 'include', // Set to 'include' if your server expects credentials (cookies, headers, etc.)
});

// WebSocket link for subscriptions
const wsLink = new GraphQLWsLink(createClient({
  url: 'ws://localhost:6001/app/graphql',
  connectionParams: {
    authorization: getAccessToken() ? `Bearer ${getAccessToken()}` : "",
  },
}));

// Split links based on operation type
const splitLink = split(
  ({ query }) => {
    const definition = query.definitions.find(
      (def) => def.kind === 'OperationDefinition'
    );
    return definition?.operation === 'subscription';
  },
  wsLink,
  uploadLink // Use upload link for HTTP operations
);



// create the middleware
const authLink = setContext((_, { headers }) => {
  // get the token from local storage
  const token = getAccessToken();
  
  // get the current locale from i18n
  const locale = i18n.global.locale.value || 'en';

  // Debug logging
  console.log('Apollo authLink - Token:', token ? 'Present' : 'Missing');
  console.log('Apollo authLink - Headers:', {
    authorization: token ? `Bearer ${token}` : "",
    'Accept-Language': locale,
  });

  // return the headers with the token and Accept-Language
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
      'Accept-Language': locale,
    },
  };
});

const apolloClient = new ApolloClient({
  link: ApolloLink.from([authLink, splitLink]), // Use split link for subscriptions
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      fetchPolicy: "network-only",
    },
    mutate: {
      fetchPolicy: "no-cache",
    },
  },
});

export default apolloClient;
